import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { actionCreators } from '@/store/ReportingYear'
import { NotFound404 } from '@/components/404'
import ReportingYearHolidayForm from '@/internal-app/components/years/ReportingYearHolidaysForm'

@localized()
class ReportingYearHolidays extends React.Component {
  componentDidMount () {
    this.props.getByYear(this.props.match.params.year)
  }

  render () {
    const { localize, reportingYear, getByYear, updateHolidays } = this.props
    if (reportingYear.fetching === true || reportingYear.updatingHolidays === true) {
      return (<LoadingIndicator />)
    }
    if (reportingYear.year === null) { return (<NotFound404 />) }

    return (
      <ReportingYearHolidayForm
        key={reportingYear.componentKey}
        localize={localize}
        reportingYear={reportingYear}
        getByYear={getByYear}
        updateHolidays={updateHolidays} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingYear: state.reportingYear,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getByYear: actionCreators.getByYear,
  updateHolidays: actionCreators.updateHolidays
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingYearHolidays)



// WEBPACK FOOTER //
// ./src/internal-app/pages/years/ReportingYearHolidays.js